import {
  FormControl,
  InputLabel,
  TextFieldProps,
  Typography,
} from "@mui/material"
import FormikSelect from "common/bit/form/FormikSelect"
import styled from "styled-components"

const Styled = {
  FormControl: styled(FormControl)``,
  FieldWrapper: styled.div<{ $marginTop: number }>`
    margin-top: ${(p) => {
      if (p?.$marginTop === 0) return "0px"
      if (p?.$marginTop) return p.$marginTop + "px"
      return "22px"
    }};
  `,
  InputLabel: styled(InputLabel)`
    transform: none !important;
    font-size: 16px;
    color: ${(p) => p.theme.colors.darkGrey};
    font-weight: 400;
  `,
  BottomText: styled(Typography).attrs({ variant: "body1" })`
    text-align: start;
    font-size: 12px;
    margin-top: -23px;
    color: ${(p) => p.theme.colors.marbleGrey};
  `,
}

type CommonSelectProps<T> = TextFieldProps & {
  name: string
  label: string
  required?: boolean
  values: T[]
  map(value: T, index?: number): { id: string | number; name: string }
  // bottomText?: string
  placeholder?: string
  marginTop?: number
}

export const toFormSelectOptions = (
  list: any[],
  idProp: string,
  nameProp: string
) => {
  return list.map((item) => ({ id: item[idProp], name: item[nameProp] }))
}

function FormSelect<T>({
  name,
  label,
  required = false,
  values,
  // bottomText,
  map,
  placeholder,
  hiddenLabel,
  marginTop,
  ...props
}: CommonSelectProps<T>) {
  return (
    <FormControl>
      <Styled.FieldWrapper $marginTop={marginTop ?? 22}>
        <FormikSelect
          label={label}
          name={name}
          required={required}
          selectValues={values}
          hiddenLabel={hiddenLabel}
          map={map}
          placeholder={placeholder}
          {...props}
        />
      </Styled.FieldWrapper>
    </FormControl>
  )
}

export default FormSelect
